import React from 'react';
import styles from '../DropDown/index.module.scss';
import Input from '../../components/Input';
import ItemsList from '../DropDown/ItemsList';
class AutoSuggest extends React.Component {
    constructor(props) {
        super(props);
        this._updateList = () => {
            const { itemsList } = this.props;
            const { list, isEmail } = this.state;
            if (isEmail && list.length <= 1 && itemsList.length > 0) {
                this.setState({
                    list: itemsList
                });
            }
            return true;
        };
        this._handleEnter = () => {
            this.setState({
                isOpen: true
            });
        };
        this._handleOut = (e) => {
            if (this._ref.current.contains(e.relatedTarget)) {
                return;
            }
            const { onBlur } = this.props;
            const { matchValue } = this.state;
            this.setState({
                isOpen: false,
                isSearchStarted: false
            });
            onBlur && onBlur(matchValue);
        };
        this._changeListOnType = ({ matchValue }) => {
            const { itemsList } = this.props;
            const newList = [];
            if (!matchValue) {
                return [];
            }
            for (let i = 0; i < itemsList.length; i++) {
                const listValue = itemsList[i].id;
                if (listValue.toLowerCase().startsWith(matchValue.toLowerCase(), 0)) {
                    newList.push(itemsList[i]);
                }
            }
            return newList;
        };
        this.extendStateOnType = ({ value }) => {
            const searchedList = this._changeListOnType({ matchValue: value });
            return {
                list: searchedList,
                isOpen: !!value
            };
        };
        this._handleChange = (e) => {
            var _a, _b;
            const { onClear, onChange } = this.props;
            const { isEmail } = this.state;
            const value = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
            if (isEmail && value && (value.match(/@/g) || []).length > 1) {
                return false;
            }
            this.setState((prevState) => (Object.assign({ matchValue: value || '', isSearchStarted: prevState.matchValue.length !== (value === null || value === void 0 ? void 0 : value.length), selectedItem: value || isEmail ? null : prevState.selectedItem }, this.extendStateOnType({ value: value || '' }))));
            if (!e || ((_b = e.target) === null || _b === void 0 ? void 0 : _b.value.length) === 0) {
                onClear();
                onChange && onChange('');
                this.setState(Object.assign({}, this.extendStateOnType({ value: '' })));
            }
            return onChange && onChange(value);
        };
        this._handleSelect = (e) => {
            const { onElemClick } = this.props;
            const { label } = e.target.dataset;
            const value = label;
            this.setState({
                isOpen: false,
                selectedItem: value,
                matchValue: value
            });
            onElemClick(value);
        };
        this._getItemLabel = () => {
            const { selectedItem, list, isEmail } = this.state;
            if (!list || !selectedItem) {
                return null;
            }
            const { label } = list.find((item) => item.id.toUpperCase() === selectedItem.toUpperCase()) || {};
            return isEmail && selectedItem ? selectedItem : label;
        };
        this._renderInput = () => {
            const { matchValue, isSearchStarted } = this.state;
            const { input, isFullWidth, ID, isDisabled } = this.props;
            return (React.createElement(Input, { isDisabled: isDisabled, name: input.name, id: ID, autoFocus: input.autoFocus, onFocus: this._handleEnter, onChange: this._handleChange, isControlledMode: true, isFullWidth: isFullWidth, isError: input.isError, description: input.description, value: isSearchStarted ? matchValue : this._getItemLabel() || matchValue, type: input.type, label: input.label, placeholder: input.placeholder, withIcon: false, isDarkBcg: input.isDarkBcg }));
        };
        this._hideList = () => {
            const { isOpen, list, matchValue, isEmail, selectedItem } = this.state;
            const { preSelectedItem } = this.props;
            return (selectedItem || !isOpen || list.length === 0 || !matchValue || (!isEmail && preSelectedItem && list.length === 1));
        };
        this._renderList = () => {
            const { list, matchValue, selectedItem, isSearchStarted, isEmail } = this.state;
            const { textSize } = this.props;
            if (this._hideList()) {
                return null;
            }
            return (React.createElement(ItemsList, { parentRef: this._ref, isEmail: isEmail, itemsList: list, isSearchStarted: isSearchStarted, onElemClick: this._handleSelect, textSize: textSize, matchValue: matchValue, selectedItem: selectedItem }));
        };
        this._ref = React.createRef();
        this.state = {
            isOpen: false,
            isSearchStarted: false,
            selectedItem: null,
            matchValue: '',
            list: null,
            isEmail: false
        };
    }
    componentDidMount() {
        const { itemsList, preSelectedItem, input } = this.props;
        const isEmail = input.type === 'email';
        this.setState({
            list: preSelectedItem ? [itemsList[0]] : [],
            selectedItem: preSelectedItem || null,
            isEmail,
            matchValue: (isEmail && preSelectedItem) || ''
        });
    }
    componentDidUpdate() {
        const { selectedItem } = this.state;
        if (!selectedItem) {
            this._updateList();
        }
    }
    render() {
        const { isFullWidth } = this.props;
        return (React.createElement("div", { onBlur: this._handleOut, ref: this._ref, className: `${styles.dropDownWrap} ${isFullWidth ? styles.fullWidth : ''}` },
            this._renderInput(),
            this._renderList()));
    }
}
export default AutoSuggest;
